import { useTenant } from '@/utils/tenant';

export function Footer() {
  const tenant = useTenant();

  return (
    <footer className="border-t border-blue-100/60 bg-white/80 px-4 py-2.5 text-center backdrop-blur-sm">
      <p className="text-[11px] font-medium text-slate-400">
        Powered by CabinetVision · CabinetVision Preview Engine
        {tenant.website && (
          <>
            {' · '}
            <a
              href={tenant.website}
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors hover:opacity-80"
              style={{ color: `rgb(var(--color-primary))` }}
            >
              {tenant.tagline?.replace(/^by /, '') || tenant.businessName}
            </a>
            {tenant.phone && (
              <>
                {' · '}
                <a
                  href={`tel:${tenant.phone.replace(/\D/g, '')}`}
                  className="transition-colors hover:opacity-80"
                  style={{ color: `rgb(var(--color-primary))` }}
                >
                  {tenant.phone}
                </a>
              </>
            )}
          </>
        )}
      </p>
    </footer>
  );
}
